import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from "app/login/login.component";
import { DisableLoginGuard } from "app/login/disable-login.guard";
import { IsUserLoggedGuard } from "app/login/is-user-logged.guard";
import { HomeComponent } from "app/home/home.component";
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { UserListComponent } from "app/user/user-list/user-list.component";
import { AddUserComponent } from "app/user/add-user/add-user.component";
import { EditUserComponent } from "app/user/edit-user/edit-user.component";
import { MyProfileComponent } from "app/user/my-profile/my-profile.component";
import { CookiePolicyComponent } from 'app/footer/cookie-policy/cookie-policy.component';
import { TermsAndConditionsComponent } from 'app/footer/terms-and-conditions/terms-and-conditions.component';
import { BrowserFailComponent } from 'app/browser-fail/browser-fail.component';
import { FooterConfigComponent } from 'app/homepage-configuration/footer-config/footer-config.component';
import { EditColumnComponent } from 'app/homepage-configuration/footer-config/edit-column/edit-column.component';
import { FooterStyleConfigComponent } from "app/homepage-configuration/footer-config/footer-style-config/footer-style-config.component";
import { FooterColumnShiftComponent } from "app/homepage-configuration/footer-config/footer-column-shift/footer-column-shift.component";
import { FooterPagesComponent } from 'app/homepage-configuration/footer-config/footer-pages/footer-pages.component';
import { FooterPageListComponent } from "app/homepage-configuration/footer-config/footer-page-list/footer-page-list.component";
import { HeaderBodyComponent } from "app/homepage-configuration/header/header-body/header-body.component";
import { HeaderTopBarComponent } from "app/homepage-configuration/header/header-top-bar/header-top-bar.component";
import { HeaderStyleConfigComponent } from "app/homepage-configuration/header/header-style-config/header-style-config.component";
import { CategoriesListComponent } from './news-intranet/categories-list/categories-list.component';
import { EditCategoryComponent } from './news-intranet/edit-category/edit-category.component';
import { NewsIntranetComponent } from './news-intranet/news-intranet.component';
import { EditNewsIntranetComponent } from './news-intranet/edit-news-intranet/edit-news-intranet.component';
import { TextContentComponent } from './text-content/text-content.component';
import { VisitingHoursComponent } from './visiting-hours/visiting-hours.component';
import { AddEditDepartmentComponent } from './visiting-hours/add-edit-department/add-edit-department.component';
import { AddEditFieldComponent } from './visiting-hours/add-edit-field/add-edit-field.component';
import { NewsletterListComponent } from './newsletter/newsletter-list/newsletter-list.component';
import { NewsletterSubscribersComponent } from './newsletter/newsletter-subscribers/newsletter-subscribers.component';
import { NewsletterSettingsComponent } from './newsletter/newsletter-settings/newsletter-settings.component';
import { NewsletterAddSubscriberComponent } from './newsletter/newsletter-subscribers/newsletter-add-subscriber/newsletter-add-subscriber.component';
import { AddNewsletterComponent } from './newsletter/add-newsletter/add-newsletter.component';
import { GdprCreateSubscribeComponent } from './gdpr-create-subscribe/gdpr-create-subscribe.component';
import { UnsubscribeNewsletterComponent } from './unsubscribe-newsletter/unsubscribe-newsletter.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { SliderComponent } from './homepage-configuration/slider/slider.component';
import { ShortFooterComponent } from './homepage-configuration/short-footer/short-footer.component';
import { WelcomeComponent } from './homepage-configuration/welcome/welcome.component';
import { FaqComponent } from './faq/faq/faq.component';
import { AddEditFaqComponent } from './faq/add-edit-faq/add-edit-faq.component';
import { KioskComponent } from './kiosk/kiosk.component';
import { AddEditKioskComponent } from './kiosk/add-edit-kiosk/add-edit-kiosk.component';
import { AddEditTextContentComponent } from './text-content/add-edit-text-content/add-edit-text-content.component';
import { UsefulContactsComponent } from './homepage-configuration/short-footer/useful-contacts/useful-contacts.component';
import { FooterListComponent } from './homepage-configuration/short-footer/footer-list/footer-list.component';
import { SliderListComponent } from './homepage-configuration/slider/slider-list/slider-list.component';
import { WelcomeListComponent } from './homepage-configuration/welcome/welcome-list/welcome-list.component';
import { ForgotPasswordConfirmComponent } from './forgot-password-confirm/forgot-password-confirm.component';
import { DepartmentsListComponent } from './appointments/departments-list/departments-list.component';
import { AppointmentsListComponent } from './appointments/appointments-list/appointments-list.component';
import { AddEditAppointmentOfficerComponent } from './appointments/appointments-officers-list/add-edit-appointment-officer/add-edit-appointment-officer.component';
import { AddEditAppointmentComponent } from './appointments/appointments-list/add-edit-appointment/add-edit-appointment.component';
import { AppointmentsOfficersListComponent } from './appointments/appointments-officers-list/appointments-officers-list.component';
import { AddEditAppointmentDepartmentComponent } from './appointments/departments-list/add-edit-appointment-department/add-edit-appointment-department.component';
import { ModuleSettingsComponent } from './module-settings/module-settings.component';
import { KioskPaymentsComponent } from './kiosk/kiosk-payments/kiosk-payments.component';
import { KioskReportsComponent } from './kiosk/kiosk-reports/kiosk-reports.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: '/home',
		pathMatch: 'full',
		canActivate: [IsUserLoggedGuard]
	},
	{
		path: 'browserfail',
		component: BrowserFailComponent,
		children: [],
		canActivate: [DisableLoginGuard]
	},
	{
		path: 'login',
		component: LoginComponent,
		children: [],
		canActivate: [DisableLoginGuard]
	},
	{
		path: 'home',
		component: HomeComponent,
		children: [],
		canActivate: [IsUserLoggedGuard]
	},
	{
		path: 'user-list', component: UserListComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-user', component: AddUserComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-user/:json', component: EditUserComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'footer-pages', component: FooterPagesComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'footer-pages/:json', component: FooterPagesComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'my-profile', component: MyProfileComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-footer', component: ShortFooterComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-footer/:json', component: ShortFooterComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'footer-list', component: FooterListComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-useful-contacts', 
		component: UsefulContactsComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'add-useful-contacts/:json', 
		component: UsefulContactsComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'edit-useful-contacts/:json', 
		component: UsefulContactsComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'view-footer-columns', component: FooterConfigComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-column', component: EditColumnComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-column/:json', component: EditColumnComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'terms-and-conditions', component: TermsAndConditionsComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'cookie-policy', component: CookiePolicyComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'footer-style-configuration', component: FooterStyleConfigComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'footer-column-shift', component: FooterColumnShiftComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'footer-page-list', component: FooterPageListComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'header-body', component: HeaderBodyComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'header-top-bar', component: HeaderTopBarComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'header-style-configuration', component: HeaderStyleConfigComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'categories-list', component: CategoriesListComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-category', component: EditCategoryComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-category/:json', component: EditCategoryComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'news-list', component: NewsIntranetComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-news', component: EditNewsIntranetComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-news-intranet/:json', component: EditNewsIntranetComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'content-text', component: TextContentComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'visiting-departments', component: VisitingHoursComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-visiting-department', component: AddEditDepartmentComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-visiting-department/:json', component: AddEditDepartmentComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-department-field', component: AddEditFieldComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-department-field/:json', component: AddEditFieldComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'newsletter-list', component: NewsletterListComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'newsletter-subscribers', component: NewsletterSubscribersComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'newsletter-settings', component: NewsletterSettingsComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-newsletter', component: AddNewsletterComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'edit-newsletter/:json', component: AddNewsletterComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'add-subscriber', component: NewsletterAddSubscriberComponent,
		canActivate: [IsUserLoggedGuard],
		children: []
	},
	{
		path: 'gdpr-create-subscriber/:email/:userEmail/:lang',
		component: GdprCreateSubscribeComponent
	},
	{
		path: 'unsubscribe-newsletter/:email',
		component: UnsubscribeNewsletterComponent
	},
	{
		path: 'gdpr/:userEmail/:lang',
		component: GdprComponent
	},
	{
		path: 'edit-slider/:json',
		canActivate: [IsUserLoggedGuard],
		component: SliderComponent
	},
	{
		path: 'add-slider',
		canActivate: [IsUserLoggedGuard],
		component: SliderComponent
	},
	{
		path: 'slider-list',
		canActivate: [IsUserLoggedGuard],
		component: SliderListComponent
	},
	{
		path: 'add-welcome',
		canActivate: [IsUserLoggedGuard],
		component: WelcomeComponent
	},
	{
		path: 'edit-welcome/:json',
		canActivate: [IsUserLoggedGuard],
		component: WelcomeComponent
	},
	{
		path: 'welcome-list',
		canActivate: [IsUserLoggedGuard],
		component: WelcomeListComponent
	},
	{
		path: 'faq',
		canActivate: [IsUserLoggedGuard],
		component: FaqComponent
	},
	{
		path: 'add-client-faq', 
		component: AddEditFaqComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'edit-client-faq/:json', 
		component: AddEditFaqComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'kiosks-list',
		canActivate: [IsUserLoggedGuard],
		component: KioskComponent
	},
	{
		path: 'kiosk-payments',
		canActivate: [IsUserLoggedGuard],
		component: KioskPaymentsComponent
	},
	{
		path: 'kiosk-reports',
		canActivate: [IsUserLoggedGuard],
		component: KioskReportsComponent
	},
	{
		path: 'add-kiosk', 
		component: AddEditKioskComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'edit-kiosk/:json', 
		component: AddEditKioskComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'edit-content-text/:terms', 
		component: AddEditTextContentComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'forgot-password-confirm/:email',
		component: ForgotPasswordConfirmComponent
	},
	{
		path: 'departments-list',
		component: DepartmentsListComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'add-edit-appointment-department',
		component: AddEditAppointmentDepartmentComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'add-edit-appointment-department/:json',
		component: AddEditAppointmentDepartmentComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'appointments-list',
		component: AppointmentsListComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'appointments-list/:json',
		component: AppointmentsListComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'add-edit-appointments/:json',
		component: AddEditAppointmentComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'appointments-officers-list',
		component: AppointmentsOfficersListComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'add-edit-appointments-officers',
		component: AddEditAppointmentOfficerComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'add-edit-appointments-officers/:json',
		component: AddEditAppointmentOfficerComponent,
		canActivate: [IsUserLoggedGuard],
	},
	{
		path: 'modules_settings',
		component: ModuleSettingsComponent,
		canActivate: [IsUserLoggedGuard],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes), BrowserModule, FormsModule],
	exports: [RouterModule]
})
export class AppRoutingModule { }
